import React, { useEffect } from 'react'
import { useMachine } from '@xstate/react'
import centroMachine from '../machines/centroMachine'
import StepsLayout from './StepsLayout'

const BaseLayout = ({ urlSchool, urlCursos, setModal, headers, IdEmp, respuesta, setLoading, pathname, modal }) => {

  const [state, send] = useMachine(centroMachine);

  useEffect(() => {
    
  console.log(state.context)
    
  }, [state])
  

  return (
    <div className='h-full w-full mb-4'>
      <StepsLayout urlSchool={urlSchool} urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} IdEmp={IdEmp} respuesta={respuesta} setLoading={setLoading} pathname={pathname} modal={modal}/>
    </div>
  )
}

export default BaseLayout